import { UpsellBookMeetingDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

type UseBookMeetingProps = {
  moduleRequested: string
}

const useBookMeeting = ({ moduleRequested }: UseBookMeetingProps) => {
  const { data, loading, error } = useQuery(UpsellBookMeetingDocument, {
    variables: {
      moduleRequested,
    },
  })

  const meetingLink = data?.upsell?.bookMeetingsConnection?.edges?.[0]?.node?.meetingLink
  const owner = data?.upsell?.bookMeetingsConnection?.edges?.[0]?.node?.owner

  return {
    meetingLink,
    owner,
    loading,
    error,
  }
}

export default useBookMeeting
